import _, { values } from 'lodash';

export const initLoc = {
  SA: 0,
  EU: 0,
  US: 0,
  UK: 0,
  APAC: 0
};
export const initVatVars = { WineryOnline: 0, EU: 0, US: 0, UK: 0, APAC: 0 };

export const initTier = {
  tier_1: {
    minValue: 0,
    maxValue: 0
  },
  tier_2: {
    minValue: 0,
    maxValue: 0
  },
  tier_3: {
    minValue: 0,
    maxValue: 0
  },
  tier_4: {
    minValue: 0,
    maxValue: 0
  },
  tier_5: {
    minValue: 0
  }
};

export const initCalcs = {
  calculatedEstimatedDTC: 0,
  estimatedDTC: _.clone(initLoc),

  tastingRoom: {
    avgSRPbyMarket: 0,
    wineryFOB: 0,
    bottlesSoldThroughDTC: 0,
    totalGrossRevenueSRPXBottlesSold: 0
  },
  managedDTCRevenue: {
    avgSRPByMarket: _.clone(initLoc),
    wineryFOB: _.clone(initLoc),
    bottlesSoldThroughDTC: _.clone(initLoc),
    totalGrossRevenueSRPXBottlesSold: _.clone(initLoc)
  },
  traditionalModel: {
    retailParticipation: {
      including: 0
    },
    fobLevelRevenueToWinery: {
      including: 0,
      excluding: 0
    },
    additionalCDRevenueToWinery: {
      including: 0
    },
    traditionalMethodTotalRevenueToWinery: {
      including: 0,
      excluding: 0
    }
  },
  fees: {
    transactionPercentage: _.clone(initLoc),
    transactionFee: _.clone(initLoc),
    network: _.clone(initLoc),
    total: _.clone(initLoc)
  },
  cellarXModel: {
    retailParticipation: {
      including: 0,
      excluding: 0
    },
    fees: {
      including: 0,
      excluding: 0
    },
    totalRevenueToWinery: {
      including: 0,
      excluding: 0
    },
    additionalRevenue: {
      excluding: 0
    }
  }
};

export const initListItems = {
  id: 1,
  skuName: '',
  fob: 0,
  production: 0,
  domestic: 0,
  international: 0,
  wineryCD: 0,

  srp: _.clone(initLoc),
  estimatedDTC_SA: 0,

  calcs: {
    ...initCalcs
  }
};

export const calculateVariables = (inpItem, inpCalcVars, wineryAvgRevenue) => {
  const src = _.cloneDeep(inpItem);
  const cv = _.cloneDeep(inpCalcVars);
  let ret = _.cloneDeep(initCalcs);

  // Calculate the estimatedDTC
  src.wineryCD = parseFloat(src.wineryCD);
  src.srp.SA = parseFloat(src.srp.SA);
  src.fob = parseFloat(src.fob);
  src.estimatedDTC_SA = parseFloat(src.estimatedDTC_SA);
  cv.dtcProjectedMarketShare.SA = parseFloat(cv.dtcProjectedMarketShare.SA);
  cv.dtcProjectedMarketShare.EU = parseFloat(cv.dtcProjectedMarketShare.EU);
  cv.dtcProjectedMarketShare.US = parseFloat(cv.dtcProjectedMarketShare.US);
  cv.dtcProjectedMarketShare.UK = parseFloat(cv.dtcProjectedMarketShare.UK);
  cv.dtcProjectedMarketShare.APAC = parseFloat(cv.dtcProjectedMarketShare.APAC);

  if (src.wineryCD !== 0 && src.estimatedDTC_SA !== 0 && cv.dtcProjectedMarketShare.SA !== 0) {
    ret.calculatedEstimatedDTC = (src.wineryCD + src.estimatedDTC_SA) / cv.dtcProjectedMarketShare.SA;

    ret.estimatedDTC.EU = Math.round(ret.calculatedEstimatedDTC * cv.dtcProjectedMarketShare.EU);
    ret.estimatedDTC.US = Math.round(ret.calculatedEstimatedDTC * cv.dtcProjectedMarketShare.US);
    ret.estimatedDTC.UK = Math.round(ret.calculatedEstimatedDTC * cv.dtcProjectedMarketShare.UK);
    ret.estimatedDTC.APAC = Math.round(ret.calculatedEstimatedDTC * cv.dtcProjectedMarketShare.APAC);

    ret.calculatedEstimatedDTC = ret.calculatedEstimatedDTC * 100;
  }

  // Tasting Room
  ret.tastingRoom.avgSRPbyMarket = src.srp.SA;
  ret.tastingRoom.wineryFOB = src.fob;
  ret.tastingRoom.bottlesSoldThroughDTC = src.wineryCD;
  ret.tastingRoom.totalGrossRevenueSRPXBottlesSold = src.srp.SA * src.wineryCD;

  // Managed DTC Revenue
  ret.managedDTCRevenue.avgSRPByMarket.SA = src.srp.SA;
  ret.managedDTCRevenue.avgSRPByMarket.EU = src.srp.EU;
  ret.managedDTCRevenue.avgSRPByMarket.US = src.srp.US;
  ret.managedDTCRevenue.avgSRPByMarket.UK = src.srp.UK;
  ret.managedDTCRevenue.avgSRPByMarket.APAC = src.srp.APAC;

  ret.managedDTCRevenue.wineryFOB.SA = src.fob;
  ret.managedDTCRevenue.wineryFOB.EU = src.fob;
  ret.managedDTCRevenue.wineryFOB.US = src.fob;
  ret.managedDTCRevenue.wineryFOB.UK = src.fob;
  ret.managedDTCRevenue.wineryFOB.APAC = src.fob;

  ret.managedDTCRevenue.bottlesSoldThroughDTC.SA = src.estimatedDTC_SA;
  ret.managedDTCRevenue.bottlesSoldThroughDTC.EU = ret.estimatedDTC.EU;
  ret.managedDTCRevenue.bottlesSoldThroughDTC.US = ret.estimatedDTC.US;
  ret.managedDTCRevenue.bottlesSoldThroughDTC.UK = ret.estimatedDTC.UK;
  ret.managedDTCRevenue.bottlesSoldThroughDTC.APAC = ret.estimatedDTC.APAC;

  ret.managedDTCRevenue.totalGrossRevenueSRPXBottlesSold.SA = src.srp.SA * src.estimatedDTC_SA;
  ret.managedDTCRevenue.totalGrossRevenueSRPXBottlesSold.EU = src.srp.EU * ret.estimatedDTC.EU;
  ret.managedDTCRevenue.totalGrossRevenueSRPXBottlesSold.US = src.srp.US * ret.estimatedDTC.US;
  ret.managedDTCRevenue.totalGrossRevenueSRPXBottlesSold.UK = src.srp.UK * ret.estimatedDTC.UK;
  ret.managedDTCRevenue.totalGrossRevenueSRPXBottlesSold.APAC = src.srp.APAC * ret.estimatedDTC.APAC;

  // Traditional Model
  ret.traditionalModel.retailParticipation.including = src.srp.SA * src.wineryCD;

  let sumEstimatedDTC =
    parseFloat(src.estimatedDTC_SA) +
    parseFloat(ret.estimatedDTC.EU) +
    parseFloat(ret.estimatedDTC.US) +
    parseFloat(ret.estimatedDTC.UK) +
    parseFloat(ret.estimatedDTC.APAC);

  ret.traditionalModel.fobLevelRevenueToWinery.including = (sumEstimatedDTC + src.wineryCD) * src.fob;
  ret.traditionalModel.fobLevelRevenueToWinery.excluding = sumEstimatedDTC * src.fob;

  ret.traditionalModel.additionalCDRevenueToWinery.including = (src.srp.SA - src.fob) * src.wineryCD;

  ret.traditionalModel.traditionalMethodTotalRevenueToWinery.including =
    ret.traditionalModel.fobLevelRevenueToWinery.including + ret.traditionalModel.additionalCDRevenueToWinery.including;
  ret.traditionalModel.traditionalMethodTotalRevenueToWinery.excluding =
    ret.traditionalModel.fobLevelRevenueToWinery.excluding;

  // Set Tier of Winery

  let tierOfWinery = '';
  let checkTier = true;

  const entries = Object.entries(cv?.tierVar || {});

  entries.forEach(function (entry) {
    if (checkTier) {
      if (entry[1].maxValue === 0 || (entry[1].maxValue >= wineryAvgRevenue && entry[1].minValue <= wineryAvgRevenue)) {
        tierOfWinery = entry[0];
        checkTier = false;
      }
    }
  });

  tierOfWinery = tierOfWinery.charAt(0).toUpperCase() + tierOfWinery.slice(1).toLowerCase();
  let tierOfWineryPercentage = 0;

  if (tierOfWinery === '') {
    tierOfWinery = 'Tier_1';
  } else {
    tierOfWineryPercentage = cv?.percentageRatesByTier[tierOfWinery];
  }

  // Fees
  ret.fees.transactionPercentage.SA = tierOfWineryPercentage?.SA / 100;
  ret.fees.transactionPercentage.EU = tierOfWineryPercentage?.EU / 100;
  ret.fees.transactionPercentage.US = tierOfWineryPercentage?.US / 100;
  ret.fees.transactionPercentage.UK = tierOfWineryPercentage?.UK / 100;
  ret.fees.transactionPercentage.APAC = tierOfWineryPercentage?.APAC / 100;

  ret.fees.transactionFee.SA = (src.srp.SA * src.estimatedDTC_SA * tierOfWineryPercentage?.SA) / 100;
  ret.fees.transactionFee.EU = (src.srp.EU * ret.estimatedDTC.EU * tierOfWineryPercentage?.EU) / 100;
  ret.fees.transactionFee.US = (src.srp.US * ret.estimatedDTC.US * tierOfWineryPercentage?.US) / 100;
  ret.fees.transactionFee.UK = (src.srp.UK * ret.estimatedDTC.UK * tierOfWineryPercentage?.UK) / 100;
  ret.fees.transactionFee.APAC = (src.srp.APAC * ret.estimatedDTC.APAC * tierOfWineryPercentage?.APAC) / 100;

  ret.fees.network.SA =
    (cv.networkFeeWarehouseManagement.SA + cv.networkFeeFreightMovement[cv.selectedNetworkFeeFreightMovement].SA) *
    src.estimatedDTC_SA;
  ret.fees.network.EU =
    (cv.networkFeeWarehouseManagement.EU + cv.networkFeeFreightMovement[cv.selectedNetworkFeeFreightMovement].EU) *
    ret.estimatedDTC.EU;
  ret.fees.network.US =
    (cv.networkFeeWarehouseManagement.US + cv.networkFeeFreightMovement[cv.selectedNetworkFeeFreightMovement].US) *
    ret.estimatedDTC.US;
  ret.fees.network.UK =
    (cv.networkFeeWarehouseManagement.UK + cv.networkFeeFreightMovement[cv.selectedNetworkFeeFreightMovement].UK) *
    ret.estimatedDTC.UK;
  ret.fees.network.APAC =
    (cv.networkFeeWarehouseManagement.APAC + cv.networkFeeFreightMovement[cv.selectedNetworkFeeFreightMovement].APAC) *
    ret.estimatedDTC.APAC;

  ret.fees.total.SA = ret.fees.transactionFee.SA + ret.fees.network.SA;
  ret.fees.total.EU = ret.fees.transactionFee.EU + ret.fees.network.EU;
  ret.fees.total.US = ret.fees.transactionFee.US + ret.fees.network.US;
  ret.fees.total.UK = ret.fees.transactionFee.UK + ret.fees.network.UK;
  ret.fees.total.APAC = ret.fees.transactionFee.APAC + ret.fees.network.APAC;

  // CellarX Model
  let retailParticipationExcl =
    src.srp.SA * src.estimatedDTC_SA +
    src.srp.EU * ret.estimatedDTC.EU +
    src.srp.US * ret.estimatedDTC.US +
    src.srp.UK * ret.estimatedDTC.UK +
    src.srp.APAC * ret.estimatedDTC.APAC;

  let retailParticipationIncl = src.srp.SA * src.wineryCD + retailParticipationExcl;

  ret.cellarXModel.retailParticipation.including = retailParticipationIncl;
  ret.cellarXModel.retailParticipation.excluding = retailParticipationExcl;

  let totalFees =
    ret.fees.transactionFee.SA +
    ret.fees.transactionFee.EU +
    ret.fees.transactionFee.US +
    ret.fees.transactionFee.UK +
    ret.fees.transactionFee.APAC +
    ret.fees.network.SA +
    ret.fees.network.EU +
    ret.fees.network.US +
    ret.fees.network.UK +
    ret.fees.network.APAC;

  ret.cellarXModel.fees.including = totalFees;
  ret.cellarXModel.fees.excluding = totalFees;

  ret.cellarXModel.totalRevenueToWinery.including = retailParticipationIncl - totalFees;
  ret.cellarXModel.totalRevenueToWinery.excluding = retailParticipationExcl - totalFees;

  ret.cellarXModel.additionalRevenue.excluding =
    ret.cellarXModel.totalRevenueToWinery.excluding -
    ret.traditionalModel.traditionalMethodTotalRevenueToWinery.excluding;

  return ret;
};
